import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14 10.252h-2.25v-4.5H14a.75.75 0 0 0 0-1.5h-2.25V2a.75.75 0 1 0-1.5 0v2.25h-4.5V2a.75.75 0 0 0-1.5 0v2.25H2a.75.75 0 0 0 0 1.5h2.25v4.5H2a.75.75 0 1 0 0 1.5h2.25V14a.75.75 0 0 0 1.5 0v-2.25h4.5V14a.75.75 0 0 0 1.5 0v-2.25H14a.75.75 0 0 0 0-1.5Zm-8.25 0v-4.5h4.5v4.5Z';
const draw24px =
  'M20,15.25H16.75V8.75H20a.75.75,0,0,0,0-1.5H16.75V4a.75.75,0,0,0-1.5,0V7.25H8.75V4a.75.75,0,0,0-1.5,0V7.25H4a.75.75,0,0,0,0,1.5H7.25v6.5H4a.75.75,0,0,0,0,1.5H7.25V20a.75.75,0,0,0,1.5,0V16.75h6.5V20a.75.75,0,0,0,1.5,0V16.75H20a.75.75,0,0,0,0-1.5Zm-11.25,0V8.75h6.5v6.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const NumberIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'number'),
) as IconWithRender;

NumberIcon.displayName = 'NumberIcon';
NumberIcon.propTypes = Icon.propTypes;
NumberIcon.renderIcon = (props) => <NumberIcon {...props} />;
export default NumberIcon;
